/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} News_Meta_DescriptionInputs */

const ja_news_meta_description = /** @type {(inputs: News_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレイブレーン(PLAYBRAIN)からの最新情報・プレスリリースをお知らせします。`)
};

const en_news_meta_description = /** @type {(inputs: News_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here are the latest news and press releases from PLAYBRAIN.`)
};

/**
* | output |
* | --- |
* | "Here are the latest news and press releases from PLAYBRAIN." |
*
* @param {News_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const news_meta_description = /** @type {((inputs?: News_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<News_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_news_meta_description(inputs)
	return en_news_meta_description(inputs)
});